/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-misused-promises */

import { CALYPSO_MEDIUM } from 'HubStyleTokens/colors';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIModal from 'UIComponents/dialog/UIModal';
import H2 from 'UIComponents/elements/headings/H2';
import UIForm from 'UIComponents/form/UIForm';
import UILink from 'UIComponents/link/UILink';
import UIList from 'UIComponents/list/UIList';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import UIAbstractProgress from 'UIComponents/progress/UIAbstractProgress';
import UINanoProgress from 'UIComponents/progress/UINanoProgress';
import styled from 'styled-components';
import { useSubscription } from '../../hooks/useSubscription';
import { TEST_IDS, URLS } from '../../utils/constants';
import { handleError } from '../../utils/errorHandling';
import { RedAlertBanner } from '../components/RedAlertBanner';
import { useUpdatePaymentMethodMutation } from './useUpdatePaymentMethodMutation';
import { useUpdatePaymentMethodQuery } from './useUpdatePaymentMethodQuery';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const linkElement = {
  Link: UILink
};
const StyledPastDueCopy = styled.div.withConfig({
  displayName: "UpdatePaymentMethodModal__StyledPastDueCopy",
  componentId: "p736g1-0"
})(["border:1px solid ", ";padding:10px 20px;"], CALYPSO_MEDIUM);
export function UpdatePaymentMethodModal({
  objectId,
  actions
}) {
  const {
    close
  } = actions;
  const {
    buyer,
    checkoutEmail
  } = useSubscription();
  const doesNotHaveBuyerEmail = !(buyer !== null && buyer !== void 0 && buyer.email);
  const customerEmail = doesNotHaveBuyerEmail ? checkoutEmail : buyer.email;
  const {
    data: queryData,
    loading: queryLoading
  } = useUpdatePaymentMethodQuery(objectId);
  const [onSubmit, {
    loading: submitLoading
  }] = useUpdatePaymentMethodMutation(objectId, customerEmail, () => {
    close();
    actions.revalidate().catch(handleError);
  });
  if (queryLoading || !queryData) {
    return /*#__PURE__*/_jsxs(UIModal, {
      "data-test-id": TEST_IDS.UpdatePaymentMethod,
      size: "auto",
      children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
        children: [/*#__PURE__*/_jsx(H2, {
          className: "p-y-4",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "subscriptions.UpdatePaymentMethodModal.title"
          })
        }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
          onClick: close
        })]
      }), /*#__PURE__*/_jsx(UIDialogBody, {
        children: /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(UIAbstractProgress, {
            Component: UINanoProgress,
            maximum: 35
          }), /*#__PURE__*/_jsx(UILoadingSpinner, {
            size: "small",
            minHeight: 100,
            layout: "centered",
            grow: true,
            showLabel: true,
            "data-test-id": "update-payment-method-modal:loading",
            label: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "subscriptions.UpdatePaymentMethodModal.loadingMessage"
            })
          })]
        })
      })]
    });
  }
  const {
    order
  } = queryData;
  return /*#__PURE__*/_jsx(UIModal, {
    "data-test-id": TEST_IDS.UpdatePaymentMethod,
    children: /*#__PURE__*/_jsxs(UIForm, {
      children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
        children: [/*#__PURE__*/_jsx(H2, {
          className: "p-y-4",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "subscriptions.UpdatePaymentMethodModal.title"
          })
        }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
          onClick: close
        })]
      }), /*#__PURE__*/_jsxs(UIDialogBody, {
        children: [doesNotHaveBuyerEmail ? /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(RedAlertBanner, {
            message: "subscriptions.NoAssociatedContactEmailAlert.modalMessage"
          }), /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: "subscriptions.UpdatePaymentMethodModal.description_jsx",
            options: {
              customerEmail
            },
            "data-test-id": "submit-update-payment-method-copy"
          })]
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'subscriptions.UpdatePaymentMethodModal.description',
          "data-test-id": "submit-update-payment-method-copy"
        }), /*#__PURE__*/_jsx(UIList, {
          className: "p-left-6 m-top-4",
          styled: true,
          children: order.subscriptionNames.map(subscriptionName => /*#__PURE__*/_jsx("span", {
            children: subscriptionName
          }, subscriptionName))
        }), order.anyPastDue ? /*#__PURE__*/_jsx(StyledPastDueCopy, {
          children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: "subscriptions.UpdatePaymentMethodModal.pastDue_jsx",
            options: {
              href: URLS.KBUpdatePaymentMethod
            },
            elements: linkElement,
            "data-test-id": "submit-update-payment-method-past-due-copy"
          })
        }) : /*#__PURE__*/_jsx(UILink, {
          href: URLS.KBUpdatePaymentMethod,
          external: true,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "subscriptions.UpdatePaymentMethodModal.exampleLinkText"
          })
        })]
      }), /*#__PURE__*/_jsxs(UIDialogFooter, {
        children: [/*#__PURE__*/_jsx(UILoadingButton, {
          "data-test-id": `${TEST_IDS.UpdatePaymentMethod}:submit`,
          loading: submitLoading,
          use: "primary",
          onClick: onSubmit,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "subscriptions.UpdatePaymentMethodModal.sendLink"
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          "data-test-id": `${TEST_IDS.UpdatePaymentMethod}:cancel`,
          use: "secondary",
          onClick: close,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "subscriptions.UpdatePaymentMethodModal.cancel"
          })
        })]
      })]
    })
  });
}